import { useEffect } from "react";
import Button from "components/atoms/Button";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import TableLoadingWrapper from "components/templates/TableLoadingWrapper";
import { StyledTableCell, StyledTableRow } from "components/templates/Tables";
import {
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableContainer,
} from "@mui/material";
import { MODAL, modalActions } from "redux/slices/modal";
import DynamicService from "services/dynamics.service";
import BlockComponent from "components/organisms/BlockComponent/BlockComponent";
import { formatAggregatorMarkupName } from "utils/aggregator.util";

function formatAggregatorName(aggregator: string) {
  return formatAggregatorMarkupName(aggregator);
}

export default function AggregatorMarkupList() {
  const dispatch = useAppDispatch();
  const aggregatorMarkups = useAppSelector(
    (state) => state.dynamics.aggregatorMarkups
  );
  const loading = useAppSelector((state) => state.dynamics.loading);

  useEffect(() => {
    DynamicService.getAggregatorMarkups();
  }, []);

  return (
    <TableContainer>
        <Table
          aria-label="aggregator markup table"
          sx={{
            minWidth: "100%",
            borderSpacing: "0 10px",
            borderBottomWidth: "0px",
            borderCollapse: "separate",
          }}
        >
          <TableLoadingWrapper
            coloumns={3}
            loading={loading}
            length={aggregatorMarkups?.length}
            message="No aggregator markups are available"
          >
            <TableHead>
              <TableRow>
                <StyledTableCell>Aggregator</StyledTableCell>
                <StyledTableCell>Markup %</StyledTableCell>
                <BlockComponent permission={"dynamics:edit"}>
                  <StyledTableCell align="center">Action</StyledTableCell>
                </BlockComponent>
              </TableRow>
            </TableHead>
            <TableBody>
              {aggregatorMarkups.map((item: any) => (
                <StyledTableRow key={item._id}>
                  <StyledTableCell>
                    {formatAggregatorName(item?.aggregator)}
                  </StyledTableCell>
                  <StyledTableCell>{item?.markup_percent}%</StyledTableCell>
                  <BlockComponent permission={"dynamics:edit"}>
                    <StyledTableCell align="center">
                      <Button
                        size="small"
                        variant="text"
                        onClick={() =>
                          dispatch(
                            modalActions.openModal({
                              type: MODAL.UPDATE_AGGREGATOR_MARKUP,
                              data: {
                                id: item?._id,
                                info: item,
                              },
                              width: "500px",
                            })
                          )
                        }
                      >
                        Edit
                      </Button>
                    </StyledTableCell>
                  </BlockComponent>
                </StyledTableRow>
              ))}
            </TableBody>
          </TableLoadingWrapper>
        </Table>
      </TableContainer>
  );
}
